export const collector_production = 'spt.apps.gov.bc.ca';
export const collector_sandbox = 'spm.apps.gov.bc.ca';
